import { decompressFromEncodedURIComponent } from 'lz-string';

type Validator = (arg: unknown) => boolean;

const parseJSON = <T>(value: string, init: T): T => {
    try {
        const parsed = JSON.parse(value);
        return parsed !== null ? { ...init, ...parsed } : init;
    } catch (e) {
        return init;
    }
};

export const readSearchParam = <T>(search: URLSearchParams, name: string, init: T, validator: Validator): T => {
    const value = search.get(name);
    if (value) {
        try {
            const parsed = JSON.parse(decompressFromEncodedURIComponent(value));
            return validator(parsed) ? { ...init, ...parsed } : init;
        } catch (e) {
            return parseJSON(value, init);
        }
    }
    return init;
};
